export default __webpack_public_path__ + "static/media/charts.9e67a688.svg";